import { render, staticRenderFns } from "./PlayStoreButton.vue?vue&type=template&id=3ecac07c&scoped=true"
import script from "./PlayStoreButton.vue?vue&type=script&lang=ts"
export * from "./PlayStoreButton.vue?vue&type=script&lang=ts"
import style0 from "./PlayStoreButton.vue?vue&type=style&index=0&id=3ecac07c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecac07c",
  null
  
)

export default component.exports